import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";
import { IDeviceCategory } from "src/app/devices/models/device-category";

export const selectFeature = (state: AppStateInterface) => state.deviceCategories;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const deviceCategoriesSelector = createSelector(
    selectFeature, 
    (state) => state.deviceCategories
);